export const TXT_FILE_FORMAT = 'text/plain';
export const DOCX_FILE_FORMAT =
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
export const PDF_FILE_FORMAT = 'application/pdf';
export const DOC_FILE_FORMAT = 'application/msword';
